import React from 'react';

import PricingActions from './PricingActions';
import CompanyVolumeCard from './CompanyVolumeCard';
import PricingBreakdownCard from './PricingBreakdownCard';
import VolumePricingTableCard from './VolumePricingTableCard';

const PricingTab = () => {
  return (
    <>
      <div className='rosetta-pricing-container'>
        {/* Pricing Breakdown */}
        <PricingBreakdownCard />

        {/* Company & Volume Configuration */}
        <CompanyVolumeCard />

        {/* Volume-Based Pricing Tiers */}
        <VolumePricingTableCard />
      </div>

      {/* Actions */}
      <PricingActions />
    </>
  );
};

export default PricingTab;
